'use strict';

var spacingNormal = "1rem";
var spacingSmall = "0.5rem";

exports.spacingNormal = spacingNormal;
exports.spacingSmall = spacingSmall;
//# sourceMappingURL=measurements-4d464873.js.map
